/** Format RAG response metadata for display (aligned with comply-ai rag.component). */

export const formatResponseSeconds = (responseTimeMs) => {
  if (responseTimeMs == null) return null;
  return `${(Number(responseTimeMs) / 1000).toFixed(2)}s`;
};

export const formatFilterStatsLine = (filterStats) => {
  const fs = filterStats;
  if (!fs) return null;

  if (fs.list_filings_matching_total != null) {
    const total = fs.list_filings_matching_total;
    const shown = fs.list_filings_returned ?? 0;
    const hidden = fs.list_filings_not_shown_due_to_limit ?? 0;
    if (total === 0) return 'No filings match your current filters.';
    if (hidden > 0) {
      return `${total} filing(s) match your filters; showing ${shown} (newest 50 by submission date). ${hidden} not listed.`;
    }
    return `${shown} filing(s) match your filters.`;
  }

  const rf = fs.retrieval_filings_filtered_out ?? 0;
  const rc = fs.retrieval_chunks_filtered_out ?? 0;
  const cf = fs.context_filings_filtered_out ?? 0;
  const ci = fs.context_items_filtered_out ?? 0;
  if (rf + rc + cf + ci === 0) return null;

  const parts = [];
  if (rf > 0 || rc > 0) {
    parts.push(`${rf} filing(s) and ${rc} chunk(s) excluded after search (did not match Postgres filters)`);
  }
  if (cf > 0 || ci > 0) {
    parts.push(`${cf} filing(s) / ${ci} context row(s) excluded when applying full filters to sources`);
  }
  return parts.join(' · ');
};

export const scorePercentForTurn = (source) => {
  if (source?.score == null) return null;
  return Math.round(Number(source.score) * 100);
};

export const isNoInformationAnswer = (turn) => {
  const answer = (turn?.response?.answer || turn?.streamingAnswer || '').trim().toLowerCase();
  if (!answer.length || answer.length > 700 || !answer.includes('provided documents')) return false;
  return answer.includes('no information') ||
    ((answer.includes('do not contain') || answer.includes('does not contain')) && answer.includes('information')) ||
    answer.includes('there is no information');
};
